import { render, staticRenderFns } from "./QcUserAdmissionDashboard.vue?vue&type=template&id=ed5ae25e&scoped=true&"
import script from "./QcUserAdmissionDashboard.vue?vue&type=script&lang=js&"
export * from "./QcUserAdmissionDashboard.vue?vue&type=script&lang=js&"
import style0 from "./QcUserAdmissionDashboard.vue?vue&type=style&index=0&id=ed5ae25e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5ae25e",
  null
  
)

export default component.exports